import React, { useCallback, useState } from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import { promptName } from '../../../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../../../Legacy';
import { Icon, NoIcon } from '../../../../concepts/resources/Icon';
import { Tip } from '../../../../ui/Tip';
import { useResolve } from '../../../Container';
import { EditorSession } from '../../../canvas/EditorSession';
import { createObserver } from '../../../canvas/ExtendableStore';
import { VoteRankingInfo, VoteRankingMode } from '../VoteRankingInfo';
import { ActionItem, Box, Float, Menu, Prompt } from './../../../../ui';

const opts = [
    ['object', 'deqo://icons/d2/sticky', 'Show Ranks By Object'],
    ['group', 'deqo://icons/deqo/group', 'Show Ranks By Topic'],
    ['-', null, null],
    ['off', null, 'Hide Ranks'],
];

const VoteRankingObserver = createObserver(VoteRankingInfo);

const VoteRankingMenu: LFC = () => {

    const session = useResolve(EditorSession);
    const onEnable = (mode: VoteRankingMode) => session.update(VoteRankingInfo, { enabled: true, mode });
    const onDisable = () => session.update(VoteRankingInfo, { enabled: false, mode: 'default' });

    return <VoteRankingObserver store={session} render={s =>
        <Menu>
            <Menu.Item checked={s.enabled && s.mode !== 'topic'} onClick={() => onEnable('object')}>
                <Icon size="1.25" src="deqo://icons/d2/sticky" />
                Show Ranks By Object
            </Menu.Item>
            <Menu.Item checked={s.enabled && s.mode === 'topic'} onClick={() => onEnable('topic')}>
                <Icon size="1.25" src="deqo://icons/deqo/group" />
                Show Ranks By Topic
            </Menu.Item>
            <Menu.Divide />
            <Menu.Item checked={!s.enabled} onClick={() => onDisable()}>
                <NoIcon size="1.25" />
                Hide Ranks
            </Menu.Item>
        </Menu>
    } />;
};

export const ShowVoteRankingMenu: LFC = () => {

    const [open, setOpen] = useState(false);
    const onToggle = useCallback(() => setOpen(!open), [open, setOpen]);
    const pn = promptName();

    return <Manager>
        <Reference>
            {({ ref }) =>
                <Tip text="View Voting Results" position="top">
                    <ActionItem className={`ignore-${pn}`} ref={ref} pressable onClick={() => setOpen(x => !x)}>
                        <Icon size="1.5" src="deqo://icons/sln/22-social-medias-rewards-rating/ranking-winner-ribbon" />
                    </ActionItem>
                </Tip>
            }
        </Reference>
        {open && <Popper placement="top">
            {({ ref, style, placement, arrowProps }) => (
                <div ref={ref} style={style} data-placement={placement}>
                    <Prompt name={pn} onAction={onToggle}>
                        <Box width="18" padding="1">
                            <Float>
                                <VoteRankingMenu />
                            </Float>
                        </Box>
                    </Prompt>
                </div>
            )}
        </Popper>}
    </Manager>;
};
